export const ORGANIZATION_AGENT_ICON_KEYS = [
    "bot",
    "sparkles",
    "search",
    "file-search",
    "book-open",
    "ticket-check",
    "list-checks",
    "github",
    "mail",
    "message-square",
    "chart",
    "code",
    "database",
    "calendar",
    "shield-check",
    "briefcase",
    "users",
    "target",
    "lightbulb",
    "workflow",
    "rocket",
    "wrench",
];
//# sourceMappingURL=organization-agent.types.js.map